var _path, _rect, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueColorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 29,
    viewBox: "0 0 87 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H29.0001V29H4C1.79086 29 0 27.2091 0 25V4Z",
    fill: "#1273CE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29.0002,
    width: 29.0001,
    height: 29,
    fill: "#1E93FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9999 0H83C85.2091 0 87 1.79086 87 4V25C87 27.2091 85.2091 29 83 29H57.9999V0Z",
    fill: "#1E93FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9999 0H83C85.2091 0 87 1.79086 87 4V25C87 27.2091 85.2091 29 83 29H57.9999V0Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueColorIcon);
export default __webpack_public_path__ + "static/media/BlueColorIcon.b29600d9dafa02177e863713feb290ee.svg";
export { ForwardRef as ReactComponent };